<template>
  <button
    tabindex="-1"
    :aria-label="altPlay"
    :class="[
      'poster-play',
      { 'available': !isLoading },
      { 'always-visible': alwaysVisible },
      { 'hide-from-medium': alwaysVisible ? false : deviceVisibility === PLAY_VISIBILITY.MOBILE },
      { 'show-from-medium': alwaysVisible ? false : deviceVisibility === PLAY_VISIBILITY.DESKTOP }
    ]">
    <wptv-icon
      :shadow="true"
      :invert="true"
      :specific-alt="altPlay"
      aria-hidden="true"
      name="play"
      :width="`${playSize}px`"
      :height="`${playSize}px`"
      data-wptv="item-poster-play-icon" />
  </button>
</template>

<script>
import { WptvIcon } from '../../icon'
import WptvPosterConfig from '../poster.config'

export default {
  name: 'PosterPlay',
  components: {
    WptvIcon
  },
  props: {
    playSize: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    visibility: {
      type: String,
      required: true
    },
    deviceVisibility: {
      type: String,
      required: true
    },
    altPlay: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      PLAY_VISIBILITY: WptvPosterConfig.PLAY_VISIBILITY
    }
  },
  computed: {
    alwaysVisible () {
      return this.visibility === this.PLAY_VISIBILITY.ALWAYS
    }
  }
}
</script>

<style lang="scss" scoped>
.poster-play {
  position: absolute;
  left: 50%;
  transform: translate(-50%,-50%);
  top: 50%;
  opacity: 0;
  z-index: 9;
  user-select: none;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: none;
  border: 0;
  box-shadow: none;
  transition: opacity 0.2s ease-in-out;
  @extend %focus-visible !optional;

  &.available {
    display: flex;
  }

  &.always-visible {
    opacity: 1;
  }
}
</style>
